import React from 'react';

export interface VariantConfig {
  slug: string;
  capiEvent: string;
  pillText: string;
  headline: React.ReactNode;
  subhead: React.ReactNode;
  questionText: string;
  captionText?: string;
  noButtonCustomRoute?: string;
  bubbleLender?: string;
}

export const VARIANT_CONFIGS: Record<string, VariantConfig> = {
  PCP_HP: {
    slug: '/pcp-hp',
    capiEvent: 'lp_view_pcphp',
    pillText: 'Welcome — let’s get started.',
    headline: (
      <>
        Did you have car finance between <span className="text-primary">2007</span> and{' '}
        <span className="text-primary">2024</span>?
      </>
    ),
    subhead: (
      <>
        The FCA estimates the average claim is worth{' '}
        <span className="text-primary font-bold">&pound;1,658*</span> per 2 agreements.
      </>
    ),
    questionText: 'Did you have car finance between 2007 and 2024?',
  },
  BLACK_HORSE: {
    slug: '/black-horse',
    capiEvent: 'lp_view_blackhorse',
    pillText: 'Welcome — let’s get started.',
    headline: (
      <>
        Did you finance a car through <span className="text-primary">Black Horse</span>?
      </>
    ),
    subhead: (
      <>
        Between 2007 and 2024, Black Horse customers could be owed{' '}
        <span className="text-primary font-bold">&pound;1,658*</span> on average.
      </>
    ),
    questionText: 'Did you finance a car through Black Horse?',
    noButtonCustomRoute: '/12-million',
    bubbleLender: 'Black Horse',
  },
  FCA_SCHEME: {
    slug: '/fca-scheme',
    capiEvent: 'lp_view_fcascheme',
    pillText: 'FCA scheme — now open.', // Pre-approved shorter layout pill fallback to prevent ugly double-line wrap on narrow devices
    headline: (
      <>
        Did you finance a car between <span className="text-primary">2007</span> and{' '}
        <span className="text-primary">2024</span>?
      </>
    ),
    subhead: (
      <>
        Average claim worth <span className="text-primary font-bold">&pound;1,658*</span> per 2
        agreements. Check potential eligibility in 60 seconds.
      </>
    ),
    questionText: 'Did you finance a car between 2007 and 2024?',
  },
  TWELVE_MILLION: {
    slug: '/12-million',
    capiEvent: 'lp_view_12million',
    pillText: 'Welcome — let’s get started.',
    headline: (
      <>
        Estimated <span className="text-primary">12.1 million</span> UK car finance deals mis-sold.
      </>
    ),
    subhead: (
      <>
        If you financed a car between 2007 and 2024, the average claim is{' '}
        <span className="text-primary font-bold">&pound;1,658*</span>.
      </>
    ),
    questionText: 'Estimated 12.1 million UK car finance deals mis-sold.',
  },
  DEFAULT: {
    slug: '/',
    capiEvent: 'lp_view_default',
    pillText: 'Welcome — let’s get started.',
    headline: (
      <>
        Did you finance a car between <span className="text-primary">2007</span> and{' '}
        <span className="text-primary">2024</span>?
      </>
    ),
    subhead: (
      <>
        The average claim is worth <span className="text-primary font-bold">&pound;1,658*</span> per
        2 agreements. FCA-confirmed scheme.
      </>
    ),
    questionText: 'Did you finance a car between 2007 and 2024?',
  },
};

export const getActiveVariantConfig = (pathName: string): VariantConfig => {
  const normalized = pathName ? (pathName.startsWith('/') ? pathName : '/' + pathName) : '';
  const cleanPath = normalized.replace(/\/$/, '') || '/';
  if (cleanPath === '/pcp-hp') return VARIANT_CONFIGS.PCP_HP;
  if (cleanPath === '/black-horse') return VARIANT_CONFIGS.BLACK_HORSE;
  if (cleanPath === '/fca-scheme') return VARIANT_CONFIGS.FCA_SCHEME;
  if (cleanPath === '/12-million') return VARIANT_CONFIGS.TWELVE_MILLION;
  return VARIANT_CONFIGS.DEFAULT;
};
